<div class="text-center loginscreen">
  <div>
    <h3>You have been logged out. Thanks for visiting!</h3>
    <a href="/login" (click)="redirectToLogin()">Back to Login Page</a>
  </div>
</div>
